export class PriceRuleProductNumberModel {
    public priceRuleProductNumberId: string;
    public productNumberTypeCode: string;
    public productNumber: string;
    public providerId: string;
    public supplierId: string;
    public excludeFlag: boolean;
    public displaySequence: number;
}